export default "__VITE_ASSET__C40xBhR3__"